import React, { FC } from 'react';
import RestaurantIcon from '../icon/RestaurantIcon';
import classNames from 'classnames';
import HomeIcon from '../icon/HomeIcon';
import ItemIcon from '../icon/ItemIcon';
import { useParams } from 'react-router';

const BaseFooter: FC = () => {
    const { accountId } = useParams<{ accountId: string }>();
    const coreUrl = `${process.env.REACT_APP_CORE_APP_URL}/account/${accountId}`;
    return (
        <div className={`flex justify-center pb-24 pt-16 bg-white flex-shrink-0`}>
            <div className={classNames([`flex flex-col items-center w-60 mx-10 cursor-pointer`, 'text-primary'])}>
                <div className="text-20">
                    <HomeIcon />
                </div>
                <span className={`text-10 `}>Home</span>
            </div>
            <div
                className={classNames([`flex flex-col items-center w-60 mx-10 cursor-pointer`, 'text-primary-70'])}
                onClick={() => {
                    window.location.href = `${coreUrl}/items`;
                }}
            >
                <div className="text-20">
                    <ItemIcon />
                </div>
                <span className={`text-10`}>Items</span>
            </div>
            <div
                className={classNames([`flex flex-col items-center w-60 mx-10 cursor-pointer`, 'text-primary-70'])}
                onClick={() => {
                    window.location.href = `${coreUrl}/setting`;
                }}
            >
                <div className="text-20">
                    <RestaurantIcon />
                </div>
                <span className={`text-10`}>Business</span>
            </div>
        </div>
    );
};

export default BaseFooter;
